import React from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { AuthForm } from "@/components/AuthForm";
import { useAuth } from "@/context/AuthContext";
import { loginLanding } from "@/lib/owner";

export const AuthDialog = () => {
  const { authOpen, authMode, closeAuth } = useAuth();
  const navigate = useNavigate();
  // Admin login lands on the Inbox (desktop) or the owner mobile home (phone); members stay where they were.
  const onSuccess = (me) => { closeAuth(); if (me?.is_admin) navigate(loginLanding(me)); };
  return (
    <Dialog open={authOpen} onOpenChange={(o) => { if (!o) closeAuth(); }}>
      <DialogContent data-testid="auth-dialog" className="sm:max-w-[420px] bg-popover border-border">
        <DialogTitle className="sr-only">Sign in to BareFootage</DialogTitle>
        <AuthForm initialMode={authMode || "login"} onSuccess={onSuccess} />
      </DialogContent>
    </Dialog>
  );
};
